/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const OpenBookIcon = /*#__PURE__*/ createSvgIcon(
  'OpenBookIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4.4.5h13.1v14.647l-3.055 4.736-9.876-1.498a2.151 2.151 0 01-.654-.198A2.28 2.28 0 012.5 15.99V2.453A1.93 1.93 0 014.39.5h.01zm.006 1a.93.93 0 00-.906.943V16.02a1.28 1.28 0 00.805 1.244l.02.008.019.01c.114.057.236.095.362.111l.009.002 9.24 1.401 2.545-3.944V1.5H4.406z"
            fill="currentColor"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M3.5 2.454a.94.94 0 00.914.946l.03.001L14.7 4.898V19.33h-1V5.762L4.355 4.4A1.94 1.94 0 012.5 2.446l1 .008z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
  true
);

export default OpenBookIcon;
